import styled from 'styled-components';

export const Divider = styled.hr`
  border: none;
  margin: ${({ margin }) => margin};
  border-bottom: 0.5px solid var(--default-gray);
`;
